import {
  TableField,
  defaultCurrencyFormatter,
  defaultDateFormatter,
  defaultTruncaTexto,
} from "../../table-field";

const nra = {
  key: "NumeroAnoContrato",
  label: "Nº/Ano",
  tdClass: ["align-middle, naoQuebrar"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
};
const tipo = {
  key: "Tipo",
  label: "Modalidade",
  tdClass: ["align-middle, quebrarPorPalavraHard"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
};

const procedimentoOrigem = {
  key: "ProcedimentoOrigem",
  label: "Procedimento de Origem",
  tdClass: ["align-middle, quebrarPorPalavraHard"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
};

const objeto = {
  key: "Objeto",
  label: "Objeto",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
  formatter: defaultTruncaTexto,
};
const inicioVigencia = {
  key: "InicioVigencia",
  label: "Início Vigência",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: true,
  formatter: defaultDateFormatter,
};

const fimVigencia = {
  key: "FimVigencia",
  label: "Fim Vigência",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: true,
  formatter: defaultDateFormatter,
};

const dtAssinatura = {
  key: "DtAssinatura",
  label: "Dt. Assinatura",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: true,
  formatter: defaultDateFormatter,
};
const situacao = {
  key: "Situacao",
  label: "Situação",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const actions = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions", "min20rem"],
  thClass: "text-center",
  sortable: false,
};

export const fieldsContratosConsulta: TableField[] = [
  nra,
  tipo,
  procedimentoOrigem,
  objeto,
  inicioVigencia,
  fimVigencia,
  dtAssinatura,
  situacao,
  actions,
];

/*export const fieldsLicitacoes: TableField[] = [
  nra,
  modalidade,
  objeto,
  valorEstimado,
  valorLicitado,
  dtHomologacao,
  situacao,
  actions,
];*/

export const fieldsImportacao: TableField[] = [
  nra,
  procedimentoOrigem,
  objeto,
  inicioVigencia,
  fimVigencia,
  dtAssinatura
];
